import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { modifyLocalForm } from "../../redux/actions-exporter";
import { useNavigate } from "react-router-dom";
import "../repeats/mainBtn/MainBtn.css";
import { format } from "date-fns";
import he from "date-fns/locale/he";
// bootstrap
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

//components
import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";

//images
import bannerImg from "../../assets/images/TII/0d29cde6ea92435fc56819d5d1f3d55a.jpg";

import galleryImg1 from "../../assets/images/MT/6.jpg";
import galleryImg2 from "../../assets/images/MT/GettyImages-135385164_pczbmr.jpg";
import galleryImg3 from "../../assets/images/MT/moving-checklist-2000-6ec63f4c4aa94bf9b9cb32f80bfd97a7.jpg";
import galleryImg4 from "../../assets/images/MT/6-Common-Mistakes-to-Avoid-When-Hiring-a-Moving-Company.jpeg";
import galleryImg5 from "../../assets/images/MT/AdobeStock_300477109-min_a23ba322c2da1cd76ade9dd3d3983ed1_2000.jpeg";
import galleryImg6 from "../../assets/images/MT/movers-collegeville.jpg";
import AddMoving from "../storage/AddMoving";
import DatePicker from "react-datepicker";

const LEAD_SOURCE = "הזמנת הובלה אונליין";

const TransportOnlineAddress = ({ mainLogo }) => {
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [start, setStart] = useState(true);
  const formRedux = useSelector((state) => state.form);
  const [form, setForm] = useState(formRedux);
  const [fromAddress, setFromAddress] = useState("");
  const [fromLocation, setFromLocation] = useState({});
  const [toAddress, setToAddress] = useState("");
  const [toLocation, setToLocation] = useState({});

  // useEffect(() => {
  //   if (start) document.querySelector(".homeTitle").scrollIntoView();
  //   setStart(false);
  // }, [start]);

  const getDistanceMatrix = (service, data) =>
    new Promise((resolve, reject) => {
      service.getDistanceMatrix(data, (response, status) => {
        if (status === "OK") {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });

  const getDistance = async (fromLocation, toLocation) => {
    const service = new window.google.maps.DistanceMatrixService();
    const result = await getDistanceMatrix(service, {
      origins: [fromLocation],
      destinations: [toLocation],
      travelMode: "DRIVING",
    });
    return result.rows[0].elements[0].distance.value;
  };

  const handleForward = async (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      setStart(true);
      e.stopPropagation();
    } else {
      setValidated(true);
      let deliveryDistance = 0;
      try {
        deliveryDistance = Math.ceil(
          (await getDistance(fromLocation, toLocation)) / 1000
        );
      } catch (error) {
        console.log(error);
      }
      const formWithDelivery = {
        ...form,
        deliveryDistance,
      };
      dispatch(modifyLocalForm(formWithDelivery));
      navigate("/transportonlineitems");
    }
    setValidated(true);
  };

  const handleExtraFieldChange = (e) => {
    if (e.target.name === "timemoveflexible") {
      setForm({
        ...form,
        extraFields: {
          ...form.extraFields,
          [e.target.name]: e.target.checked,
        },
      });
    } else {
      setForm({
        ...form,
        extraFields: {
          ...form.extraFields,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  const onDateChange = (date, field) => {
    setForm({
      ...form,
      extraFields: {
        ...form.extraFields,
        [field]: date,
      },
    });
  };

  const handleOnPlaceSelected = (place, inputRef, header) => {
    if (header === "מהיכן?") {
      setFromAddress(inputRef.value);
      setFromLocation(place.geometry.location);
    } else if (header === "להיכן?") {
      setToAddress(inputRef.value);
      setToLocation(place.geometry.location);
    }
  };

  useEffect(() => {
    setForm({
      ...form,
      extraFields: {
        ...form.extraFields,
        toaddress: toAddress,
        fromaddress: fromAddress,
      },
    });
  }, [fromAddress, toAddress]);

  useEffect(() => {
    if (!form?.extraFields?.timemove) {
      setForm({
        ...form,
        extraFields: {
          ...form.extraFields,
          timemove: "07:00-09:00",
        },
      });
    }
  }, []);

  const galleryArr = [
    {
      img: galleryImg1,
    },
    {
      img: galleryImg2,
    },
    {
      img: galleryImg3,
    },
    {
      img: galleryImg4,
    },
    {
      img: galleryImg5,
    },
    {
      img: galleryImg6,
    },
  ];

  return (
    <div className="transportFewItems">
      {/* <div className="page_banner">
        <img src={bannerImg} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הזמנת הובלה אונליין</h1>
            <p>רק למלא פרטים ולשלוח</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/transportapartment" />
            <MainBtn
              text="הזמנה בעזרת נציג"
              link="/transportgetback"
              isLight={true}
            />
          </div>
        </div>
      </div> */}

      {/* <Pros /> */}

      <div className="servicesDiv">
        <h1 className="homeTitle">פרטי הובלה</h1>
        <div className="splitDiv">
          {/* <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="שירותי הובלות"
              galleryArr={galleryArr}
            />
          </div> */}

          <div className="formSide">
            <Form
              className="formBox"
              noValidate
              validated={validated}
              onSubmit={handleForward}
            >
              <AddMoving
                handleExtraFieldChange={handleExtraFieldChange}
                header="מהיכן?"
                withKindOfMoving={true}
                values={form}
                handleOnPlaceSelected={handleOnPlaceSelected}
              />

              <AddMoving
                handleExtraFieldChange={handleExtraFieldChange}
                header="להיכן?"
                withKindOfMoving={false}
                values={form}
                handleOnPlaceSelected={handleOnPlaceSelected}
              />

              <h3 className="subTitle">מתי?</h3>

              <Row className="mb-3 row">
                <Form.Group as={Col} className="mb-3" controlId="formBasicDate">
                  <Form.Label className="fw-semibold mb-2">תאריך</Form.Label>
                  <DatePicker
                    name="datemove"
                    dateFormat="dd-MM-yyyy"
                    placeholderText="בחר תאריך"
                    minDate={
                      form?.extraFields?.datemove
                        ? new Date(form?.extraFields?.datemove)
                        : new Date()
                    }
                    selected={
                      form?.extraFields?.datemove
                        ? new Date(form?.extraFields?.datemove)
                        : ""
                    }
                    onChange={(date) =>
                      onDateChange(format(date, "yyyy-MM-dd"), "datemove")
                    }
                    customInput={
                      <Form.Control
                        readOnly
                        autoComplete="off"
                        autoCorrect="off"
                        type="text"
                        name="datemove"
                      />
                    }
                    locale={he}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    נא להכניס תאריך
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3 row">
                <Form.Group as={Col} className="mb-3" controlId="formBasicName">
                  <Form.Label className="fw-semibold mb-2">
                    שעת תחילת הובלה
                  </Form.Label>
                  <Form.Select
                    aria-label="Select move time"
                    name="timemove"
                    onChange={handleExtraFieldChange}
                    value={form?.extraFields?.timemove ?? "07:00-09:00"}
                    // defaultValue="07:00-09:00"
                  >
                    <option value="07:00-09:00">07:00-09:00</option>
                    <option value="09:00-13:00">09:00-13:00</option>
                    <option value="12:00-15:00">12:00-15:00</option>
                    <option value="15:00-18:00">15:00-18:00</option>
                    <option value="18:00-21:00">18:00-21:00</option>
                  </Form.Select>
                  <Form.Check
                    reverse
                    checked={form?.extraFields?.timemoveflexible ?? false}
                    type="checkbox"
                    name="timemoveflexible"
                    label="גמיש"
                    variant="warning"
                    onChange={handleExtraFieldChange}
                  />
                </Form.Group>
              </Row>
              {/* <div className="contact-btnDiv send">
                <MainBtn button text="לבחירת פריטים" onClick={handleForward} />
              </div> */}
              <Button
                style={{
                  background: "var(--primary)",
                  border: "none",
                  width: "100%",
                }}
                text="שליחה"
                type="submit"
                className="filter-btn"
              >
                לבחירת פריטים
              </Button>
            </Form>
          </div>
        </div>
      </div>

      {/* <Reviews />
      <Footer /> */}
    </div>
  );
};

export default TransportOnlineAddress;
